'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

require('./polyfill/childnode-remove');

require('./polyfill/promise');

var _eventUtility = require('@nimius/event-utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Promise polyfill for IE 10 & 11
// This polyfill can be removed, once both, IE10 and 11 are dropped.
(0, _eventUtility.onPageLoadComplete)(function () {

    // TODO Use data-attributes instead of class
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('[data-nimcore-video-element]')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var wrapper = _step.value;

            var hasOverlay = wrapper.hasAttribute('data-nimcore-video-element-has-overlay');
            var hasLightbox = wrapper.hasAttribute('data-nimcore-video-element-has-lightbox');
            var overlay = wrapper.querySelector('[data-nimcore-video-element-overlay]');
            var player = wrapper.querySelector('iframe, video');

            // Initialize differently, depending on which mode the video element
            // is started in.
            if (hasLightbox) {
                initializeLightbox(wrapper, player);
            } else if (hasOverlay) {
                initializeOverlay(overlay, player);
            }

            // Update sizes on resize
            var ratio = getAspectRatio(wrapper);
            var size = parseInt(wrapper.getAttribute('data-nimcore-video-element-size')) || wrapper.getBoundingClientRect().width;
            updateSize(wrapper, ratio, size);
            window.addEventListener('resize', (0, _eventUtility.throttle)(updateSize.bind(null, wrapper, ratio, size), 250));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});

/**
 * Initializes the lightbox functionality on the given element.
 * In this mode a lightbox opens with the video in it's playing state once the user
 * clicks on the wrapper element.
 *
 * @param {HTMLElement} wrapper
 * @param {HTMLIFrameElement|HTMLVideoElement} player
 */
// ChildNode.remove polyfill for IE 10 & 11.
// This polyfill can be removed, once both, IE10 and 11 are dropped.
function initializeLightbox(wrapper, player) {
    player.remove();

    // Photoswipe needs elements to have 100% width and height.
    player.style.width = '100%';
    player.style.height = '100%';

    var items = [{
        html: player.outerHTML
    }];

    import( /* webpackChunkName: "photoswipe-initialization.async" */'./photoswipe/photoswipe-initialization').then(function (swipe) {
        wrapper.addEventListener('click', function () {
            var photoSwipe = swipe.initializePhotoSwipe(items, { closeOnScroll: false });
            startVideoPlayback(photoSwipe.container.querySelector('video, iframe'));
            photoSwipe.listen('close', function () {
                photoSwipe.container.querySelector('video, iframe').remove();
            });
        });
    });
}

/**
 * Initializes the player in overlay mode.
 * In this mode the player waits to be clicked and then starts playing the video inline.
 *
 * @param {HTMLElement} overlay
 * @param {HTMLIFrameElement|HTMLVideoElement} player
 */
function initializeOverlay(overlay, player) {
    player.style.display = 'none';
    overlay.addEventListener('click', function (e) {
        e.preventDefault();
        overlay.remove();
        startVideoPlayback(player);
    });
}

/**
 * Starts the video playback of the given player.
 * @param {HTMLIFrameElement|HTMLVideoElement} player
 */
function startVideoPlayback(player) {
    player.style.display = '';

    if (player instanceof HTMLIFrameElement) {
        player.setAttribute('src', player.getAttribute('data-src'));
    } else if (player instanceof HTMLVideoElement) {
        player.play();
    } else {
        throw new Error('Player must be either iFrame or Video');
    }
}

/**
 * Updates the size of the video to scale with it's parent, retaining it's aspect
 * ratio but stop at a maximum size.
 * @param wrapper
 * @param ratio
 * @param size
 */
function updateSize(wrapper, ratio, size) {
    var parentWidth = wrapper.parentNode.getBoundingClientRect().width;

    if (parentWidth > size) {
        wrapper.style.width = size + 'px';
        wrapper.style.height = size / ratio + 'px';
        wrapper.style.paddingTop = '';
    } else {
        wrapper.style.width = 'auto';
        wrapper.style.height = 'auto';
        wrapper.style.paddingTop = 1 / ratio * 100 + '%';
    }
}

/**
 * Returns the correct aspect ratio (width / height) for the given wrapper.
 * The aspect ratio can be set in the `data-nimcore-video-element-aspect-ratio` property.
 * This property can either contain a single number containing the ratio as width/height
 * or as two numbers divided by slash (/) or colon (:).
 *
 * Defaults to 16/9.
 *
 * @param {HTMLElement} wrapper
 * @returns {number}
 */
function getAspectRatio(wrapper) {
    var parts = wrapper.getAttribute('data-nimcore-video-element-aspect-ratio').split(/[/:]/);
    switch (parts.length) {
        case 0:
            return 16 / 9;
        case 1:
            return parseFloat(parts[0].trim());
        default:
            return parseFloat(parts[0].trim()) / parseFloat(parts[1].trim());
    }
}


//////////////////
// WEBPACK FOOTER
// ./Resources/Private/Javascript/video-element.js
// module id = 132
// module chunks = 3